/**
 * TanStack Query hooks for `cake-integration-via-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	cakeIntegrationViaApiQueryKeys,
	type CreateCakeIntegrationViaApiBody,
	type ListCakeIntegrationViaApiResponse,
	type CakeIntegrationViaApiRow,
} from "./api";

export function useCakeIntegrationViaApiList(): UseQueryResult<ListCakeIntegrationViaApiResponse, Error> {
	return useQuery({
		queryKey: cakeIntegrationViaApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useCakeIntegrationViaApiCreate(): UseMutationResult<CakeIntegrationViaApiRow, Error, CreateCakeIntegrationViaApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: cakeIntegrationViaApiQueryKeys.all });
		},
	});
}

export function useCakeIntegrationViaApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: cakeIntegrationViaApiQueryKeys.all });
		},
	});
}
